import { cursor } from '../utility/cursor.js'

const cursorEl = document.querySelector('#cursor')
const cursorCircleEl = cursorEl.querySelector('.cursor__circle')

const cursorEvents = cursor()
const speed = 0.1 // between 0 and 1
const lastPos = { x: -1, y: -1 }

cursorEvents.onUpdate(pos => {
	if (lastPos.x === -1) {
		lastPos.x = pos.easedX
		lastPos.y = pos.easedY
	}

	const diffX = Math.round(pos.x - lastPos.x)
	const diffY = Math.round(pos.y - lastPos.y)
	
	const translate = 'translate3d(' + pos.easedX + 'px ,' + pos.easedY + 'px, 0)'

	cursorEl.style.transform = translate

	if (pos.percentX > 0.25) {
		cursorEl.classList.add('right')
	} else {
		cursorEl.classList.remove('right')
	}

	lastPos.x = pos.easedX
	lastPos.y = pos.easedY
})


const cursorModifiers = document.querySelectorAll('[cursor-class]')

cursorModifiers.forEach(cursorModifier => {
	var className = cursorModifier.getAttribute('cursor-class')
	var dataTitle = cursorModifier.getAttribute('data-title')

  cursorModifier.addEventListener('mouseenter', event => {
		cursorEl.classList.add(className, 'active')
		if (dataTitle) {
			cursorEl.setAttribute('data-title', dataTitle)
		} else {
			cursorEl.setAttribute('data-title', '')
		}
	})
  
	cursorModifier.addEventListener('mouseleave', event => {
    if (className === 'link') {
      cursorEl.classList.remove(className, 'link')
    } else {
      cursorEl.classList.remove(className, 'active')
    }
  })
})